import api from "./api";

export const getAICommandCenterData = async () => {
    const [shipmentsRes, iotRes, blockchainRes, logsRes] =
        await Promise.allSettled([
            api.get("/Shipment/all"),
            api.get("/IoTDevice"),
            api.get("/BlockchainLog"),
            api.get("/SystemLog"),
        ]);

    const shipments =
        shipmentsRes.status === "fulfilled" && Array.isArray(shipmentsRes.value.data)
            ? shipmentsRes.value.data
            : [];

    const devices =
        iotRes.status === "fulfilled" && Array.isArray(iotRes.value.data)
            ? iotRes.value.data
            : [];

    const blockchainLogs =
        blockchainRes.status === "fulfilled" && Array.isArray(blockchainRes.value.data)
            ? blockchainRes.value.data
            : [];

    const systemLogs =
        logsRes.status === "fulfilled" && Array.isArray(logsRes.value.data)
            ? logsRes.value.data
            : [];

    return {
        aiRisk: 6,
        aiConfidence: 98,
        routeOptimization: 92,
        fraudRisk: 3,
        etaAccuracy: 95,
        trustPrediction: 94,
        securityThreat: systemLogs.length > 10 ? 12 : 4,
        anomalyEvents: systemLogs.filter((x) =>
            JSON.stringify(x).toLowerCase().includes("anomaly")
        ).length,
        shipments: shipments.length,
        devices: devices.length,
        blockchainEvents: blockchainLogs.length,
        recommendations: [
            "Maintain current route optimization strategy.",
            "Monitor IoT devices with weak signal.",
            "Continue blockchain integrity verification.",
            "Review shipments with low trust score.",
        ],
    };
};

export default {
    getAICommandCenterData,
};